export default __webpack_public_path__ + "static/media/background2.759bf457.png";